import { render, staticRenderFns } from "./security_document_request_detail.vue?vue&type=template&id=1f93f70f&scoped=true"
import script from "./security_document_request_detail.vue?vue&type=script&lang=js"
export * from "./security_document_request_detail.vue?vue&type=script&lang=js"
import style0 from "./security_document_request_detail.vue?vue&type=style&index=0&id=1f93f70f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93f70f",
  null
  
)

export default component.exports